export * from './communication.service';
export * from './core-state.service';
export * from './theme.service';
export * from './notification.factory';
export * from './logger.service';

import { CommunicationService } from './communication.service';
import { CoreStateService } from './core-state.service';
import { LoggerService } from './logger.service';
import { NotificationFactory } from './notification.factory';
import { ThemeService } from './theme.service';


export const ApplicationServices = [
    CommunicationService,
    CoreStateService,
    ThemeService,
    NotificationFactory,
    LoggerService
];